var _a;
import { CountryCode } from '@cta-portal/webapp-common/lib/api/schema';
export var countryCodeToCountry = (_a = {},
    _a[CountryCode.AF] = "Afghanistan",
    _a[CountryCode.AX] = "\u00C5land Islands",
    _a[CountryCode.AL] = "Albania",
    _a[CountryCode.DZ] = "Algeria",
    _a[CountryCode.AS] = "American Samoa",
    _a[CountryCode.AD] = "Andorra",
    _a[CountryCode.AO] = "Angola",
    _a[CountryCode.AI] = "Anguilla",
    _a[CountryCode.AQ] = "Antarctica",
    _a[CountryCode.AG] = "Antigua and Barbuda",
    _a[CountryCode.AR] = "Argentina",
    _a[CountryCode.AM] = "Armenia",
    _a[CountryCode.AW] = "Aruba",
    _a[CountryCode.AU] = "Australia",
    _a[CountryCode.AT] = "Austria",
    _a[CountryCode.AZ] = "Azerbaijan",
    _a[CountryCode.BS] = "Bahamas",
    _a[CountryCode.BH] = "Bahrain",
    _a[CountryCode.BD] = "Bangladesh",
    _a[CountryCode.BB] = "Barbados",
    _a[CountryCode.BY] = "Belarus",
    _a[CountryCode.BE] = "Belgium",
    _a[CountryCode.BZ] = "Belize",
    _a[CountryCode.BJ] = "Benin",
    _a[CountryCode.BM] = "Bermuda",
    _a[CountryCode.BT] = "Bhutan",
    _a[CountryCode.BO] = "Bolivia, Plurinational State of",
    _a[CountryCode.BQ] = "Bonaire, Sint Eustatius and Saba",
    _a[CountryCode.BA] = "Bosnia and Herzegovina",
    _a[CountryCode.BW] = "Botswana",
    _a[CountryCode.BV] = "Bouvet Island",
    _a[CountryCode.BR] = "Brazil",
    _a[CountryCode.IO] = "British Indian Ocean Territory",
    _a[CountryCode.BN] = "Brunei Darussalam",
    _a[CountryCode.BG] = "Bulgaria",
    _a[CountryCode.BF] = "Burkina Faso",
    _a[CountryCode.BI] = "Burundi",
    _a[CountryCode.KH] = "Cambodia",
    _a[CountryCode.CM] = "Cameroon",
    _a[CountryCode.CA] = "Canada",
    _a[CountryCode.CV] = "Cape Verde",
    _a[CountryCode.KY] = "Cayman Islands",
    _a[CountryCode.CF] = "Central African Republic",
    _a[CountryCode.TD] = "Chad",
    _a[CountryCode.CL] = "Chile",
    _a[CountryCode.CN] = "China",
    _a[CountryCode.CX] = "Christmas Island",
    _a[CountryCode.CC] = "Cocos (Keeling) Islands",
    _a[CountryCode.CO] = "Colombia",
    _a[CountryCode.KM] = "Comoros",
    _a[CountryCode.CG] = "Congo",
    _a[CountryCode.CD] = "Congo, the Democratic Republic of the",
    _a[CountryCode.CK] = "Cook Islands",
    _a[CountryCode.CR] = "Costa Rica",
    _a[CountryCode.CI] = "C\u00F4te d'Ivoire",
    _a[CountryCode.HR] = "Croatia",
    _a[CountryCode.CU] = "Cuba",
    _a[CountryCode.CW] = "Cura\u00E7ao",
    _a[CountryCode.CY] = "Cyprus",
    _a[CountryCode.CZ] = "Czech Republic",
    _a[CountryCode.DK] = "Denmark",
    _a[CountryCode.DJ] = "Djibouti",
    _a[CountryCode.DM] = "Dominica",
    _a[CountryCode.DO] = "Dominican Republic",
    _a[CountryCode.EC] = "Ecuador",
    _a[CountryCode.EG] = "Egypt",
    _a[CountryCode.SV] = "El Salvador",
    _a[CountryCode.GQ] = "Equatorial Guinea",
    _a[CountryCode.ER] = "Eritrea",
    _a[CountryCode.EE] = "Estonia",
    _a[CountryCode.ET] = "Ethiopia",
    _a[CountryCode.FK] = "Falkland Islands (Malvinas)",
    _a[CountryCode.FO] = "Faroe Islands",
    _a[CountryCode.FJ] = "Fiji",
    _a[CountryCode.FI] = "Finland",
    _a[CountryCode.FR] = "France",
    _a[CountryCode.GF] = "French Guiana",
    _a[CountryCode.PF] = "French Polynesia",
    _a[CountryCode.TF] = "French Southern Territories",
    _a[CountryCode.GA] = "Gabon",
    _a[CountryCode.GM] = "Gambia",
    _a[CountryCode.GE] = "Georgia",
    _a[CountryCode.DE] = "Germany",
    _a[CountryCode.GH] = "Ghana",
    _a[CountryCode.GI] = "Gibraltar",
    _a[CountryCode.GR] = "Greece",
    _a[CountryCode.GL] = "Greenland",
    _a[CountryCode.GD] = "Grenada",
    _a[CountryCode.GP] = "Guadeloupe",
    _a[CountryCode.GU] = "Guam",
    _a[CountryCode.GT] = "Guatemala",
    _a[CountryCode.GG] = "Guernsey",
    _a[CountryCode.GN] = "Guinea",
    _a[CountryCode.GW] = "Guinea-Bissau",
    _a[CountryCode.GY] = "Guyana",
    _a[CountryCode.HT] = "Haiti",
    _a[CountryCode.HM] = "Heard Island and McDonald Islands",
    _a[CountryCode.VA] = "Holy See (Vatican City State)",
    _a[CountryCode.HN] = "Honduras",
    _a[CountryCode.HK] = "Hong Kong",
    _a[CountryCode.HU] = "Hungary",
    _a[CountryCode.IS] = "Iceland",
    _a[CountryCode.IN] = "India",
    _a[CountryCode.ID] = "Indonesia",
    _a[CountryCode.IR] = "Iran, Islamic Republic of",
    _a[CountryCode.IQ] = "Iraq",
    _a[CountryCode.IE] = "Ireland",
    _a[CountryCode.IM] = "Isle of Man",
    _a[CountryCode.IL] = "Israel",
    _a[CountryCode.IT] = "Italy",
    _a[CountryCode.JM] = "Jamaica",
    _a[CountryCode.JP] = "Japan",
    _a[CountryCode.JE] = "Jersey",
    _a[CountryCode.JO] = "Jordan",
    _a[CountryCode.KZ] = "Kazakhstan",
    _a[CountryCode.KE] = "Kenya",
    _a[CountryCode.KI] = "Kiribati",
    _a[CountryCode.KP] = "Korea, Democratic People's Republic of",
    _a[CountryCode.KR] = "Korea, Republic of",
    _a[CountryCode.KW] = "Kuwait",
    _a[CountryCode.KG] = "Kyrgyzstan",
    _a[CountryCode.LA] = "Lao People's Democratic Republic",
    _a[CountryCode.LV] = "Latvia",
    _a[CountryCode.LB] = "Lebanon",
    _a[CountryCode.LS] = "Lesotho",
    _a[CountryCode.LR] = "Liberia",
    _a[CountryCode.LY] = "Libya",
    _a[CountryCode.LI] = "Liechtenstein",
    _a[CountryCode.LT] = "Lithuania",
    _a[CountryCode.LU] = "Luxembourg",
    _a[CountryCode.MO] = "Macao",
    _a[CountryCode.MK] = "Macedonia, the Former Yugoslav Republic of",
    _a[CountryCode.MG] = "Madagascar",
    _a[CountryCode.MW] = "Malawi",
    _a[CountryCode.MY] = "Malaysia",
    _a[CountryCode.MV] = "Maldives",
    _a[CountryCode.ML] = "Mali",
    _a[CountryCode.MT] = "Malta",
    _a[CountryCode.MH] = "Marshall Islands",
    _a[CountryCode.MQ] = "Martinique",
    _a[CountryCode.MR] = "Mauritania",
    _a[CountryCode.MU] = "Mauritius",
    _a[CountryCode.YT] = "Mayotte",
    _a[CountryCode.MX] = "Mexico",
    _a[CountryCode.FM] = "Micronesia, Federated States of",
    _a[CountryCode.MD] = "Moldova, Republic of",
    _a[CountryCode.MC] = "Monaco",
    _a[CountryCode.MN] = "Mongolia",
    _a[CountryCode.ME] = "Montenegro",
    _a[CountryCode.MS] = "Montserrat",
    _a[CountryCode.MA] = "Morocco",
    _a[CountryCode.MZ] = "Mozambique",
    _a[CountryCode.MM] = "Myanmar",
    _a[CountryCode.NA] = "Namibia",
    _a[CountryCode.NR] = "Nauru",
    _a[CountryCode.NP] = "Nepal",
    _a[CountryCode.NL] = "Netherlands",
    _a[CountryCode.NC] = "New Caledonia",
    _a[CountryCode.NZ] = "New Zealand",
    _a[CountryCode.NI] = "Nicaragua",
    _a[CountryCode.NE] = "Niger",
    _a[CountryCode.NG] = "Nigeria",
    _a[CountryCode.NU] = "Niue",
    _a[CountryCode.NF] = "Norfolk Island",
    _a[CountryCode.MP] = "Northern Mariana Islands",
    _a[CountryCode.NO] = "Norway",
    _a[CountryCode.OM] = "Oman",
    _a[CountryCode.PK] = "Pakistan",
    _a[CountryCode.PW] = "Palau",
    _a[CountryCode.PS] = "Palestine, State of",
    _a[CountryCode.PA] = "Panama",
    _a[CountryCode.PG] = "Papua New Guinea",
    _a[CountryCode.PY] = "Paraguay",
    _a[CountryCode.PE] = "Peru",
    _a[CountryCode.PH] = "Philippines",
    _a[CountryCode.PN] = "Pitcairn",
    _a[CountryCode.PL] = "Poland",
    _a[CountryCode.PT] = "Portugal",
    _a[CountryCode.PR] = "Puerto Rico",
    _a[CountryCode.QA] = "Qatar",
    _a[CountryCode.RE] = "R\u00E9union",
    _a[CountryCode.RO] = "Romania",
    _a[CountryCode.RU] = "Russian Federation",
    _a[CountryCode.RW] = "Rwanda",
    _a[CountryCode.BL] = "Saint Barth\u00E9lemy",
    _a[CountryCode.SH] = "Saint Helena, Ascension and Tristan da Cunha",
    _a[CountryCode.KN] = "Saint Kitts and Nevis",
    _a[CountryCode.LC] = "Saint Lucia",
    _a[CountryCode.MF] = "Saint Martin (French part)",
    _a[CountryCode.PM] = "Saint Pierre and Miquelon",
    _a[CountryCode.VC] = "Saint Vincent and the Grenadines",
    _a[CountryCode.WS] = "Samoa",
    _a[CountryCode.SM] = "San Marino",
    _a[CountryCode.ST] = "Sao Tome and Principe",
    _a[CountryCode.SA] = "Saudi Arabia",
    _a[CountryCode.SN] = "Senegal",
    _a[CountryCode.RS] = "Serbia",
    _a[CountryCode.SC] = "Seychelles",
    _a[CountryCode.SL] = "Sierra Leone",
    _a[CountryCode.SG] = "Singapore",
    _a[CountryCode.SX] = "Sint Maarten (Dutch part)",
    _a[CountryCode.SK] = "Slovakia",
    _a[CountryCode.SI] = "Slovenia",
    _a[CountryCode.SB] = "Solomon Islands",
    _a[CountryCode.SO] = "Somalia",
    _a[CountryCode.ZA] = "South Africa",
    _a[CountryCode.GS] = "South Georgia and the South Sandwich Islands",
    _a[CountryCode.SS] = "South Sudan",
    _a[CountryCode.ES] = "Spain",
    _a[CountryCode.LK] = "Sri Lanka",
    _a[CountryCode.SD] = "Sudan",
    _a[CountryCode.SR] = "Suriname",
    _a[CountryCode.SJ] = "Svalbard and Jan Mayen",
    _a[CountryCode.SZ] = "Swaziland",
    _a[CountryCode.SE] = "Sweden",
    _a[CountryCode.CH] = "Switzerland",
    _a[CountryCode.SY] = "Syrian Arab Republic",
    _a[CountryCode.TW] = "Taiwan, Province of China",
    _a[CountryCode.TJ] = "Tajikistan",
    _a[CountryCode.TZ] = "Tanzania, United Republic of",
    _a[CountryCode.TH] = "Thailand",
    _a[CountryCode.TL] = "Timor-Leste",
    _a[CountryCode.TG] = "Togo",
    _a[CountryCode.TK] = "Tokelau",
    _a[CountryCode.TO] = "Tonga",
    _a[CountryCode.TT] = "Trinidad and Tobago",
    _a[CountryCode.TN] = "Tunisia",
    _a[CountryCode.TR] = "Turkey",
    _a[CountryCode.TM] = "Turkmenistan",
    _a[CountryCode.TC] = "Turks and Caicos Islands",
    _a[CountryCode.TV] = "Tuvalu",
    _a[CountryCode.UG] = "Uganda",
    _a[CountryCode.UA] = "Ukraine",
    _a[CountryCode.AE] = "United Arab Emirates",
    _a[CountryCode.GB] = "United Kingdom",
    _a[CountryCode.US] = "United States",
    _a[CountryCode.UM] = "United States Minor Outlying Islands",
    _a[CountryCode.UY] = "Uruguay",
    _a[CountryCode.UZ] = "Uzbekistan",
    _a[CountryCode.VU] = "Vanuatu",
    _a[CountryCode.VE] = "Venezuela, Bolivarian Republic of",
    _a[CountryCode.VN] = "Viet Nam",
    _a[CountryCode.VG] = "Virgin Islands, British",
    _a[CountryCode.VI] = "Virgin Islands, U.S.",
    _a[CountryCode.WF] = "Wallis and Futuna",
    _a[CountryCode.EH] = "Western Sahara",
    _a[CountryCode.YE] = "Yemen",
    _a[CountryCode.ZM] = "Zambia",
    _a[CountryCode.ZW] = "Zimbabwe",
    _a);
export function getCountryFromCountryCode(countryCode) {
    return countryCodeToCountry[countryCode];
}
export function getCountryCodeFromString(inputString) {
    if (!getCountryFromCountryCode(inputString))
        throw new Error('Invalid country code.');
    return inputString;
}
